import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import Select, { type SelectOption } from "../../../components/ui/Select";

interface PaymentFiltersProps {
	filters: { status: string };
	onFilterChange: (filters: { status?: string }) => void;
	paymentCount: number;
}

const STATUS_OPTIONS: SelectOption[] = [
	{ value: "", label: "All Status" },
	{ value: "pending", label: "Pending" },
	{ value: "paid", label: "Paid" },
	{ value: "overdue", label: "Overdue" },
	{ value: "cancelled", label: "Cancelled" },
	{ value: "refunded", label: "Refunded" },
];

const PaymentFilters: React.FC<PaymentFiltersProps> = ({
	filters,
	onFilterChange,
	paymentCount,
}) => {
	const clearFilters = () => {
		onFilterChange({ status: "" });
	};

	const hasActiveFilters = filters.status !== "";

	return (
		<div className="bg-card border border-border rounded-lg card-shadow">
			<div className="p-4 border-b border-border">
				<div className="flex items-center justify-between">
					<h3 className="font-semibold text-foreground">Filters</h3>
					{hasActiveFilters && (
						<Button
							variant="ghost"
							size="sm"
							onClick={clearFilters}
							className="text-xs"
						>
							Clear all
						</Button>
					)}
				</div>

				<p className="text-sm text-muted-foreground mt-1">
					{paymentCount} payment{paymentCount !== 1 ? "s" : ""} found
				</p>
			</div>

			<div className="p-4 space-y-4">
				{/* Payment Status Filter */}
				<div>
					<label className="block text-sm font-medium text-foreground mb-2">
						Payment Status
					</label>
					<Select
						value={filters.status}
						options={STATUS_OPTIONS}
						onValueChange={(value) =>
							onFilterChange({ status: value as string })
						}
					/>
				</div>

				{/* Quick Filter Buttons */}
				<div>
					<label className="block text-sm font-medium text-foreground mb-2">
						Quick Filters
					</label>
					<div className="space-y-2">
						<Button
							variant={filters.status === "overdue" ? "default" : "outline"}
							size="sm"
							onClick={() =>
								onFilterChange({
									status: filters.status === "overdue" ? "" : "overdue",
								})
							}
							className="w-full justify-start text-xs"
						>
							<Icon name="AlertTriangle" size={14} className="mr-2" />
							Overdue Payments
						</Button>

						<Button
							variant={filters.status === "pending" ? "default" : "outline"}
							size="sm"
							onClick={() =>
								onFilterChange({
									status: filters.status === "pending" ? "" : "pending",
								})
							}
							className="w-full justify-start text-xs"
						>
							<Icon name="Clock" size={14} className="mr-2" />
							Pending Payments
						</Button>

						<Button
							variant={filters.status === "paid" ? "default" : "outline"}
							size="sm"
							onClick={() =>
								onFilterChange({
									status: filters.status === "paid" ? "" : "paid",
								})
							}
							className="w-full justify-start text-xs"
						>
							<Icon name="CheckCircle" size={14} className="mr-2" />
							Paid Payments
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PaymentFilters;
